import { type BaseCommandProperties } from './command-definition.ts';
import { type CommandConstructor, type SubscriberName } from './command-service-types.ts';

export const throwNoSubscriptionsDevelopmentError = (subscriberName: SubscriberName) => {
  if (process.env.NODE_ENV !== 'production') {
    throw new Error(
      `No subscriptions for system ${subscriberName}. If encountering in a test, try commandService.dispose() in your beforeEach BEFORE TestEnvironment.create()`,
    );
  }
};

export const throwExistingSubscriberDevelopmentError = <
  C extends BaseCommandProperties = BaseCommandProperties,
>(
  subscriberName: SubscriberName,
  command: CommandConstructor<C>,
) => {
  if (process.env.NODE_ENV !== 'production') {
    throw new Error(
      `${subscriberName} already subscribed to ${command.name}. If encountering in a test, try commandService.dispose() in your beforeEach`,
    );
  }
};
